import { getLocaleString } from 'utilities/locales';

window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.WebPaymentSdk.init());

Sq.Shop.WebPaymentSdk = {
  utils: Sq.Shop.Utils,

  async init() {
    if ($('.web-payment-sdk').length === 0) {
      return;
    }

    this.getHtml();
    this.getData();
    await this.createForm();
    this.bindEvents();
  },

  getHtml() {
    this.$form = $('.web-payment-sdk');
    this.$digitalWalletInfo = $('#digital-wallet-info');
    this.$scaInfo = $('#sca-info');
    this.$submitButton = $('#card-button');
    this.$googlePayButton = $('#google-pay-button');
  },

  getData() {
    this.dataPostUrl = this.$form.attr('data-post-url');
    this.dataCompleteUrl = this.$form.attr('data-complete-url');
    this.orderNumber = $('#order-number').val();
    this.payapiAppId = $('#payapi-app-id').val();
    this.locationId = $('#payapi-location-id').val();
    this.authToken = $('meta[name=csrf-token]').attr('content');
    this.cardIntent = $('#cardIntent').val();
  },

  // shop logic (handle create payment / complete order)
  handleSuccess(nonce, cardData, verificationToken) {
    $.ajax({
      url: this.dataPostUrl,
      type: 'POST',
      data: {
        nonce,
        card_data: {
          card_brand: cardData.brand,
          last_4: cardData.last4,
          exp_year: cardData.expYear,
          exp_month: cardData.expMonth,
        },
        order_number: this.orderNumber,
        authenticity_token: this.authToken,
        verification_token: verificationToken,
      },
    })
      .done(() => {
        window.location = this.dataCompleteUrl;
      })
      .fail((xhr) => {
        this.enableSubmits();
        this.utils.flashBanner().update({
          message: `${xhr.status} error submitting payment. Please try again.`,
          state: 'error',
          timeout: false,
        });
      });
  },

  // web payment sdk stuff

  buildPaymentRequest(payments) {
    return payments.paymentRequest({
      countryCode: this.getDigitalWalletField('country').val(),
      currencyCode: this.getDigitalWalletField('currency').val(),
      total: {
        amount: this.getDigitalWalletField('first_payment_total').val(),
        label: 'Square Shop',
      },
    });
  },

  verificationDetails() {
    const cardIntent = this.cardIntent.toUpperCase();
    return {
      intent: cardIntent,
      squareProduct: 'MARKET',
      billingContact: {
        givenName: this.getScaField('given_name').val(),
        familyName: this.getScaField('family_name').val(),
      },
      ...(['CHARGE', 'CHARGE_AND_STORE'].includes(cardIntent)
        ? {
            amount: this.getScaField('amount').val(),
            currencyCode: Sq.Environment['currency_code'],
          }
        : {}),
    };
  },

  async runSCA(token) {
    const verificationResults = await this.payments.verifyBuyer(
      token,
      this.verificationDetails()
    );
    return verificationResults.token;
  },

  async tokenize(paymentMethod) {
    this.disableSubmits();
    const tokenResult = await paymentMethod.tokenize();
    if (tokenResult.status === 'OK') {
      const token = tokenResult.token;
      const scaToken = await this.runSCA(token);
      const cardData = tokenResult.details.card;
      this.handleSuccess(token, cardData, scaToken);
    } else {
      this.enableSubmits();
    }
  },

  async initializeCard(payments) {
    const card = await payments.card();
    await card.attach('#card-container');
    return card;
  },

  async initializeGooglePay(payments) {
    const paymentRequest = this.buildPaymentRequest(payments);

    const googlePay = await payments.googlePay(paymentRequest);
    await googlePay.attach('#google-pay-button');

    return googlePay;
  },

  async initializeApplePay(payments) {
    const paymentRequest = this.buildPaymentRequest(payments);
    const applePay = await payments.applePay(paymentRequest);
    // Note: You do not need to `attach` applePay.
    return applePay;
  },

  async createForm() {
    if (!window.Square) {
      throw new Error('Square.js failed to load properly');
    }
    const payments = window.Square.payments(this.payapiAppId, this.locationId);
    payments.setLocale(getLocaleString());
    try {
      this.card = await this.initializeCard(payments);
    } catch {
      return;
    }
    if (this.$digitalWalletInfo) {
      try {
        this.googlePay = await this.initializeGooglePay(payments);
      } catch {
        // do nothing
      }
      try {
        this.applePay = await this.initializeApplePay(payments);
      } catch {
        // do nothing
      }
    }
    this.payments = payments; // this needs to be saved for the SCA call
  },

  // bind

  bindEvents() {
    this.$submitButton.on('click', () => this.tokenize(this.card));
    if (this.googlePay) {
      this.$googlePayButton.on('click', () => this.tokenize(this.googlePay));
    }
    if (this.applePay) {
      this.$applePayButton.on('click', () => this.tokenize(this.applePay));
    }
  },

  // getting fields

  getDigitalWalletField(id) {
    return this.$digitalWalletInfo.find(`#${id}`);
  },

  getScaField(id) {
    return this.$scaInfo.find(`#${id}`);
  },

  // enable/disable submit

  enableSubmits() {
    this.$submitButton.removeClass('disabled').prop('disabled', false);
    if (this.$applePayButton) {
      this.$applePayButton.removeClass('disabled').prop('disabled', false);
    }
    if (this.$googlePayButton) {
      this.$googlePayButton.removeClass('disabled').prop('disabled', false);
    }
  },

  disableSubmits() {
    this.$submitButton.addClass('disabled').prop('disabled', true);
    if (this.$applePayButton) {
      this.$applePayButton.addClass('disabled').prop('disabled', true);
    }
    if (this.$googlePayButton) {
      this.$googlePayButton.addClass('disabled').prop('disabled', true);
    }
  },
};
